export const Badge = ({ text, color = "gray" }: Props) => {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-${color}-100 text-${color}-800`}
    >
      {text}
    </span>
  );
};

interface Props {
  text: string;
  color?: string;
}
